(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.CalendarGuardianSync = api;
})(typeof globalThis !== 'undefined' ? globalThis : window, function () {
  const tidy = value => String(value || '').toLowerCase().normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim()
    .replace(/\bappt\b/g, 'appointment').replace(/\bmtg\b/g, 'meeting');
  const words = value => new Set(tidy(value).split(' ').filter(Boolean));
  const overlap = (a, b) => {
    const left = words(a), right = words(b);
    if (!left.size || !right.size) return 0;
    let shared = 0; left.forEach(word => { if (right.has(word)) shared++; });
    return shared / Math.max(left.size, right.size);
  };
  const time = value => value == null ? NaN : new Date(value).getTime();
  const sameOccurrence = (a, b, toleranceMinutes = 5) => {
    if (a.allDay || b.allDay) return String(a.start || '').slice(0, 10) === String(b.start || '').slice(0, 10);
    return Math.abs(time(a.start) - time(b.start)) <= toleranceMinutes * 60000;
  };
  const recurrenceKey = event => tidy(event.recurrenceId || event.originalStart || 'series');
  const exactIdentity = event => {
    const uid = event.iCalUID || event.iCalUId || event.uid;
    return uid ? `ical:${tidy(uid)}:${recurrenceKey(event)}` : '';
  };
  const score = (incoming, candidate) => {
    if (!sameOccurrence(incoming, candidate)) return 0;
    const title = overlap(incoming.title || incoming.summary || incoming.subject, candidate.title || candidate.summary || candidate.subject);
    const location = overlap(incoming.location, candidate.location);
    const aDuration = time(incoming.end) - time(incoming.start);
    const bDuration = time(candidate.end) - time(candidate.start);
    const duration = Number.isFinite(aDuration) && Number.isFinite(bDuration) && Math.abs(aDuration - bDuration) <= 10 * 60000 ? 1 : 0;
    return title * .72 + location * .12 + duration * .16;
  };
  const findMatch = (incoming, canonicals, mappings = []) => {
    if (incoming.guardianId) {
      const own = canonicals.find(event => event.guardianId === incoming.guardianId);
      if (own) return { event: own, reason: 'guardian-id', confidence: 1, ownWrite: true };
    }
    const mapped = mappings.find(item => item.connectionId === incoming.connectionId && item.providerEventId === incoming.providerEventId);
    if (mapped) {
      const own = canonicals.find(event => event.guardianId === mapped.guardianId);
      if (own) return { event: own, reason: 'provider-map', confidence: 1, ownWrite: true };
    }
    const identity = exactIdentity(incoming);
    if (identity) {
      const exact = canonicals.find(event => exactIdentity(event) === identity);
      if (exact) return { event: exact, reason: 'ical-uid', confidence: 1, ownWrite: false };
    }
    let best = null;
    canonicals.forEach(event => {
      const confidence = score(incoming, event);
      if (!best || confidence > best.confidence) best = { event, reason: 'similar-occurrence', confidence, ownWrite: false };
    });
    return best && best.confidence >= .82 ? best : null;
  };
  const stamp = (event, connectionId) => ({
    guardianId: event.guardianId,
    guardianRevision: Number(event.revision || 1),
    origin: 'calendar-guardian',
    idempotencyKey: `calendar-guardian:${event.guardianId}:${event.revision || 1}:${connectionId}`
  });
  const classifyInbound = (incoming, state) => {
    const match = findMatch(incoming, state.canonicals || [], state.mappings || []);
    if (!match) return { action: 'create', match: null };
    if (match.ownWrite) return { action: 'acknowledge', match };
    return { action: 'merge', match };
  };
  return { normalize: tidy, titleSimilarity: overlap, sameOccurrence, exactIdentity, score, findMatch, stamp, classifyInbound };
});
